import Vue from "vue";
import axios from "axios";
import qs from "qs";
import VueAxios from "vue-axios";
import VueCookies from "vue-cookies";
Vue.use(VueAxios, axios, VueCookies);

export default {
  name: "loginInternal",
  data: () => ({
    node_send: process.env.VUE_APP_NODE_MACINARY,
    email: "",
    pass: "",
    error: ""
  }),
  methods: {
    conection: function(url, methods, data) {
      let data_send = {
        method: methods,
        headers: {
          Authorization: "Bearer " + this.Token
        },
        data: qs.stringify(data),
        url: this.node_send + url
      };
      return axios(data_send);
    },
    loginNow: function() {
      let url = "signin";
      let type = "POST";
      let credential = {
        email: this.email,
        password: this.pass
      };
      this.conection(url, type, credential)
        .then(response => {
          var key = response.data.token;
          window.$cookies.set("ACC_MC", key);
          this.$router.push({ path: "/machine/macinaryDashboard" });
        })
        .catch(error => {
          this.error = error.response.data.message;
        });
    }
  },
  mounted() {
    this.Token = window.$cookies.get("ACC_MC");
    if (this.Token) {
      this.$router.push({ path: "/machine/macinaryDashboard" });
    }
  }
};
